import { useQuery } from "@enkor/react-query";

import BaseApi from "@logics/api/baseApi";
import { UserDetailCategory } from "@models/data-contracts";
import { ApiResponseDto } from "@models/client";

const categoryApi = new BaseApi("/category");

const initialData = {
  statusCode: 200,
  message: "ok",
  data: [
    {
      id: 1,
      name: "🥟 Food/Drink",
    },
    {
      id: 2,
      name: "🎨 Arts/Cultures",
    },
    {
      id: 3,
      name: "⚾️ Outdoors Activities",
    },
    {
      id: 4,
      name: "👬 Socializing",
    },
  ],
};

export const categoryQueryKeys = {
  all: ["CATEGORY"],
};

// ------------------------------------------------------------------------

export const useFetchCategoryQuery = () => {
  return useQuery({
    queryKey: categoryQueryKeys.all,
    queryFn: () => categoryApi.get<ApiResponseDto<UserDetailCategory[]>>(""),
    select: (response) => {
      const categoriesMap: { [key: number]: string } = response.data.reduce(
        (acc, current) => {
          acc[current.id] = current.name;
          return acc;
        },
        {},
      );

      return categoriesMap;
    },
    staleTime: Infinity,
    initialData,
  });
};
